// extracted by mini-css-extract-plugin
export default {"mobileRoot":"MobileTip_mobileRoot__UNWml","mobileError":"MobileTip_mobileError__X8HF6","image":"MobileTip_image__og7Im","message":"MobileTip_message__LlYCu"};